import MDEditor from "@uiw/react-md-editor";
import React, { useEffect, useState } from "react";
import { getPapers } from "../../api/PapersApi";
import ContainerCard from "../../common/CardContainer";
import { SynodPapers } from "../../data/SynodPapers";

/** "2.3 MB" / "480 KB" */
export function formatFileSize(bytes: number): string {
  if (!bytes) {
    return "";
  }
  return bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

interface SynodPapersContentProps {
  papers: SynodPapers | null;
}

/** The note and paper links; shared by the home page and the admin preview. */
export function SynodPapersContent({ papers }: SynodPapersContentProps) {
  const hasNote = !!papers?.contentMarkdown?.trim();
  const list = papers?.papers ?? [];

  if (!hasNote && list.length === 0) {
    return <p className="text-muted mb-0">No notice papers available.</p>;
  }
  return (
    <>
      {hasNote ? (
        <div className="sl-papers-note" data-color-mode="light">
          <MDEditor.Markdown source={papers!.contentMarkdown} />
        </div>
      ) : null}
      {list.length > 0 ? (
        <ul className="sl-papers-list">
          {list.map((paper) => (
            <li key={paper.id}>
              <a href={paper.url} target="_blank" rel="noreferrer">
                {paper.title}
              </a>
              {paper.sizeBytes ? <span className="sl-papers-meta">PDF · {formatFileSize(paper.sizeBytes)}</span> : null}
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
}

/** Home page "Synod Papers" card, managed from Admin > Synod Papers. */
function SynodPapersBlock() {
  const [papers, setPapers] = useState<SynodPapers | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getPapers()
      .then(setPapers)
      .catch((e: Error) => setError(e.message));
  }, []);

  return (
    <ContainerCard heading="Synod Papers">
      {error ? <p className="text-muted mb-0">Synod papers could not be loaded. Try refreshing the page.</p> : <SynodPapersContent papers={papers} />}
    </ContainerCard>
  );
}

export default SynodPapersBlock;
